// src/lib/queryClient.ts
import { isServer, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { toApiError } from "../utils/general/axios.utils";
//import { toApiError } from "../utils";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // Evita toasts en SSR o prefetch
      if (isServer) return;
      toast.error(error.message);
    },
  }),
  defaultOptions: {
    queries: {
      // Evita reintentos infinitos en 4xx
      retry: (failureCount, error) => {
        const e = toApiError(error);
        if (e.status && e.status >= 400 && e.status < 500) return false;
        return failureCount < 1; // reintenta 2 veces en 5xx o red
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Lanza errores al consumer con el objeto normalizado
      /* throwOnError: (error) => {
        throw toApiError(error);
      }, */
      refetchOnWindowFocus: false,
    },
    mutations: {
      /* throwOnError: (error) => {
        throw toApiError(error);
      }, */
      retry: false,
    },
  },
});
